export default "__VITE_ASSET__b70c460b__"